const ANONYMOUS_PRESENTER_HASH = 'ic-ap-hash';

export const getSlugFromUrl = (): string => window.location.pathname.match(/^\/(?:presentation|room)\/([^/?]+)/)?.[1] ?? '';

export const getRunFileStorageKey = (presId: string, roomRunfileId: string | undefined = '', slug = ''): string => {
    return `ncc-runfileId-${presId}-${roomRunfileId}-${slug}`;
};

export const getAnonymousPresenterHash = (): string => localStorage.getItem(ANONYMOUS_PRESENTER_HASH) || '';

export const setAnonymousPresenterHash = (hash: string): void => {
    localStorage.setItem(ANONYMOUS_PRESENTER_HASH, hash);
};

export const removeAnonymousPresenterHash = (): void => {
    localStorage.removeItem(ANONYMOUS_PRESENTER_HASH);
};
